/**
 * Reader for the drop-in prayer image folders: public/prayers/<PRAYER_ID>/.
 * The manifest is regenerated by scripts/build-prayer-image-manifest.js on
 * every npm start / build — edit the folders, never the JSON.
 * Conventions live in public/prayers/README.txt.
 */
import manifest from './prayerImageManifest.json';

let testOverride = null;

/** Jest hook: swap the manifest table without touching the generated file. */
export function __setPrayerFolderManifestForTests(table) {
  testOverride = table;
}

function table() {
  if (testOverride) return testOverride;
  return manifest?.prayers || {};
}

/** Whole-prayer images, alphabetical; [0] is the pinned pick. */
export function getFolderBaseImages(prayerId) {
  return table()[prayerId]?.base?.filter(Boolean) || [];
}

/** Image pinned to one verse (0-based index here); null when no NN- file. */
export function getFolderVerseImage(prayerId, verseIndex) {
  const verses = table()[prayerId]?.verses;
  if (!verses || !Number.isFinite(Number(verseIndex))) return null;
  return verses[String(Number(verseIndex) + 1)] || null;
}

/** True when the prayer has at least one base folder image. */
export function hasFolderBaseImage(prayerId) {
  return getFolderBaseImages(prayerId).length > 0;
}
